// https://vuex.vuejs.org/en/getters.html
export default {
  currentCourse: state => state.currentCourse,
}
